define.alias("shared/components/shared/ui/group-item", "calendar/components/shared/ui/group-item");